/*
  based on: https://github.com/rzeigler/waveguide-streams/blob/master/src/step.ts
  credits to original author
 */
export var SinkStepTag;
(function (SinkStepTag) {
    SinkStepTag[SinkStepTag["Cont"] = 0] = "Cont";
    SinkStepTag[SinkStepTag["Done"] = 1] = "Done";
})(SinkStepTag || (SinkStepTag = {}));
export function sinkCont(s) {
    return { _tag: SinkStepTag.Cont, state: s };
}
export function sinkDone(s, leftover) {
    return { _tag: SinkStepTag.Done, state: s, leftover };
}
export function isSinkCont(s) {
    return s._tag === SinkStepTag.Cont;
}
export function isSinkDone(s) {
    return s._tag === SinkStepTag.Done;
}
export function sinkStepLeftover(s) {
    if (s._tag === SinkStepTag.Cont) {
        return [];
    }
    else {
        return s.leftover;
    }
}
export function sinkStepState(s) {
    return s.state;
}
export function map(step, f) {
    return Object.assign(Object.assign({}, step), { state: f(step.state) });
}
export function mapWith(f) {
    return (step) => map(step, f);
}
export function traverse(F) {
    return (step, f) => F.map(f(step.state), (s1) => (Object.assign(Object.assign({}, step), { state: s1 })));
}
